import { InvoiceList } from './invoice';

export const invoceLists: InvoiceList[] = [
  {
    id: 101,
    billFrom: 'Pineapple Inc.',
    billFromEmail: 'first@xabz.com',
    billFromAddress: 'Ganesh glory,Godrej garden city,Ahmedabad.',
    billFromPhone: 979796786,
    billFromFax: 13,
    billTo: 'Redq Inc.',
    billToEmail: 'toFirst@agth.com',
    billToAddress: 'Godrej garden city,Ahmedabad.',
    billToPhone: 757575233,
    billToFax: 76,
    orders: [
      {
        itemName: 'Courge',
        unitPrice: 10,
        units: 9,
        unitTotalPrice: 90,
      },
    ],
    orderDate: new Date(),
    totalCost: 90,
    vat: 9,
    grandTotal: 99,
    status: 'Shipped',
    completed: false,
    isSelected: false,
  },
  {
    id: 102,
    billFrom: 'Pineapple.',
    billFromEmail: 'first@xabz.com',
    billFromAddress: 'Ganesh glory,Godrej garden city,Ahmedabad.',
    billFromPhone: 979796786,
    billFromFax: 13,
    billTo: 'ME Inc.',
    billToEmail: 'toFirst@agth.com',
    billToAddress: 'Godrej garden city,Ahmedabad.',
    billToPhone: 757575233,
    billToFax: 76,
    orders: [
      {
        itemName: 'Courge',
        unitPrice: 10,
        units: 9,
        unitTotalPrice: 90,
      },
    ],
    orderDate: new Date(),
    totalCost: 90,
    vat: 9,
    grandTotal: 99,
    status: 'Delivered',
    completed: false,
    isSelected: false,
  },
  {
    id: 103,
    billFrom: 'Incorporation.',
    billFromEmail: 'first@xabz.com',
    billFromAddress: 'Ahmedabad.',
    billFromPhone: 979796786,
    billFromFax: 13,
    billTo: 'Redirwed.',
    billToEmail: 'toFirst@agth.com',
    billToAddress: 'Godrej garden city,Ahmedabad.',
    billToPhone: 757575233,
    billToFax: 76,
    orders: [
      {
        itemName: 'Courge',
        unitPrice: 10,
        units: 9,
        unitTotalPrice: 90,
      },
    ],
    orderDate: new Date(),
    totalCost: 90,
    vat: 9,
    grandTotal: 99,
    status: 'Pending',
    completed: false,
    isSelected: false,
  },
  {
    id: 104,
    billFrom: 'PineappleTimes  .',
    billFromEmail: 'first@xabz.com',
    billFromAddress: 'Ganesh glory,Godrej garden city,Ahmedabad.',
    billFromPhone: 979796786,
    billFromFax: 13,
    billTo: 'RFc.',
    billToEmail: 'toFirst@agth.com',
    billToAddress: 'Godrej garden city,Ahmedabad.',
    billToPhone: 757575233,
    billToFax: 76,
    orders: [
      {
        itemName: 'Courge',
        unitPrice: 10,
        units: 9,
        unitTotalPrice: 90,
      },
    ],
    orderDate: new Date(),
    totalCost: 90,
    vat: 9,
    grandTotal: 99,
    status: 'Shipped',
    completed: false,
    isSelected: false,
  },
  {
    id: 105,
    billFrom: 'Fortune Creation',
    billFromEmail: 'first@xabz.com',
    billFromAddress: 'Ganesh glory,Godrej garden city,Ahmedabad.',
    billFromPhone: 979796786,
    billFromFax: 13,
    billTo: 'Soft solution.',
    billToEmail: 'toFirst@agth.com',
    billToAddress: 'Godrej garden city,Ahmedabad.',
    billToPhone: 757575233,
    billToFax: 76,
    orders: [
      {
        itemName: 'Courge',
        unitPrice: 10,
        units: 9,
        unitTotalPrice: 90,
      },
    ],
    orderDate: new Date('2024-10-15'),
    totalCost: 90,
    vat: 9,
    grandTotal: 99,
    status: 'Delivered',
    completed: false,
    isSelected: false,
  },
  {
    id: 106,
    billFrom: 'PineappleTimes  .',
    billFromEmail: 'first@xabz.com',
    billFromAddress: 'Ganesh glory,Godrej garden city,Ahmedabad.',
    billFromPhone: 979796786,
    billFromFax: 13,
    billTo: 'RFc.',
    billToEmail: 'toFirst@agth.com',
    billToAddress: 'Godrej garden city,Ahmedabad.',
    billToPhone: 757575233,
    billToFax: 76,
    orders: [
      {
        itemName: 'Courge',
        unitPrice: 10,
        units: 9,
        unitTotalPrice: 90,
      },
    ],
    orderDate: new Date(),
    totalCost: 90,
    vat: 9,
    grandTotal: 99,
    status: 'Shipped',
    completed: false,
    isSelected: false,
  },
  {
    id: 107,
    billFrom: 'Fortune Creation',
    billFromEmail: 'first@xabz.com',
    billFromAddress: 'Ganesh glory,Godrej garden city,Ahmedabad.',
    billFromPhone: 979796786,
    billFromFax: 13,
    billTo: 'Soft solution.',
    billToEmail: 'toFirst@agth.com',
    billToAddress: 'Godrej garden city,Ahmedabad.',
    billToPhone: 757575233,
    billToFax: 76,
    orders: [
      {
        itemName: 'Courge',
        unitPrice: 10,
        units: 9,
        unitTotalPrice: 90,
      },
    ],
    orderDate: new Date('2024-10-15'),
    totalCost: 90,
    vat: 9,
    grandTotal: 99,
    status: 'Delivered',
    completed: false,
    isSelected: false,
  },
];
